import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import './Contact.css';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: 'Message Sent!',
      description: 'Thank you for contacting AG&WESTERN. We\'ll get back to you within 24 hours.',
    });
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero section-dark">
        <div className="container">
          <div className="contact-hero-content">
            <h1>Get in Touch</h1>
            <p className="contact-subtitle">
              Have questions about our services? We're here to help.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="section">
        <div className="container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-section">
              <h2>Send Us a Message</h2>
              <p className="form-description">
                Fill out the form below and our team will respond within 24 hours.
              </p>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      placeholder="John Doe"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="john@example.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="(866) 324-9378"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      placeholder="How can we help?"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Tell us more about your inquiry..."
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary submit-btn">
                  <Send size={20} />
                  Send Message
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="contact-info-section">
              <h2>Contact Information</h2>
              <p className="info-description">
                Reach out to us through any of these channels.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <Mail size={24} />
                  </div>
                  <div className="contact-item-content">
                    <h4>Email</h4>
                    <p>info@agwesternrail.com</p>
                    <p>Aaron.Gregory@agwesternrail.com</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-item-icon">
                    <Phone size={24} />
                  </div>
                  <div className="contact-item-content">
                    <h4>Phone</h4>
                    <p>Main: (866) 324-9378</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-item-icon">
                    <MapPin size={24} />
                  </div>
                  <div className="contact-item-content">
                    <h4>Location</h4>
                    <p>AG&WESTERN Rail Inc.</p>
                    <p>Richmond, Virginia</p>
                  </div>
                </div>
              </div>

              <div className="business-hours">
                <h4>Customer Service</h4>
                <div className="hours-list">
                  <div className="hours-item">
                    <span>Available</span>
                    <span>24/7 Support</span>
                  </div>
                  <div className="hours-item">
                    <span>Phone Support</span>
                    <span>Daily 6AM - 10PM</span>
                  </div>
                  <div className="hours-item">
                    <span>Email Response</span>
                    <span>Within 24 hours</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;